module.exports = new __parcel__URL__("guide_medium_text.d9af8241.png").toString();